import React from "react";
import { View, StyleSheet, Platform } from "react-native";
import { WebView } from 'react-native-webview';
const LiveChat = props => {
    return (
        <View style={styles.container}>
            {
                Platform.OS === 'web' ? <iframe src='https://www.goftino.com/c/xj8jwe' height={"100%"} width={"100%"} frameBorder={0} /> : <View style={{ flex: 1 }}>:<WebView originWhitelist={['*']}
                    source={{ uri: 'https://www.goftino.com/c/xj8jwe', baseUrl: '' }}
                    style={{ flex: 1, height: 2 }}
                />
                </View>
            }
        </View>
    )
}

const styles = StyleSheet.create(
    {
        container: {
            flexDirection: 'row',
            flex: 1,
            flexWrap: 'wrap',
            justifyContent: 'center',
            margin: 0,
            padding:0
        }
    }
)

export default LiveChat;